export default "__VITE_ASSET__CNCn3tAX__"